/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud # Usage This API is used in the `https://yrityksille.elisa.fi/` pages. # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BillCharacteristic } from './billCharacteristic.js';


export interface BillDeliveryMethod { 
    /**
     * Billing channel used to deliver the invoice. SFDC: Billing_Account__c.Billing_Channel__c. ELECTRONIC = YV, PAPER = PA, EMAIL = EM
     */
    id?: BillDeliveryMethod.IdEnum;
    /**
     * Billing channel used to deliver the invoice. SFDC: Billing_Account__c.Billing_Channel__c. PA is paper free of charge; CPA is paper chargeable; EM is email; YV is electronic invoice; CDP3 is direct payment plus chargeable paper.
     */
    deliveryMethodType?: string;
    /**
     * Characteristics of the bill delivery method, including electronic operator and e-invoice address.
     */
    characteristic?: Array<BillCharacteristic>;
}
export namespace BillDeliveryMethod {
    export type IdEnum = 'ELECTRONIC' | 'PAPER' | 'EMAIL';
    export const IdEnum = {
        ELECTRONIC: 'ELECTRONIC' as IdEnum,
        PAPER: 'PAPER' as IdEnum,
        EMAIL: 'EMAIL' as IdEnum
    };
}


